<section>
    <div class="flex justify-between items-end">
        <div>
            <h1>HOD Details</h1>
        </div>
        <div class="flex items-center gap-3">
            <div class="dropdown dropdown-bottom dropdown-end">
                <div tabindex="0" role="button" class="btn btn-sm btn-primary border flex items-center">
                    Action <i class="ri-arrow-down-s-line"></i>
                </div>
                <ul tabindex="0"
                    class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
                    <li><a>Manage Permissions</a></li>
                    <li><a><i class="ri-delete-bin-line text-red-500"></i> Delete User</a></li>
                </ul>
            </div>

        </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-5 mt-5">
        <!-- profile -->
        <div class="lg:col-span-1 hod-profile-scroll">
            @if (isFetching) {
            <div class="flex justify-center py-10">
                <app-loader></app-loader>
            </div>
            } @else if (hodData) {
            <app-staff-student-common-profile-view [profileData]="hodData"></app-staff-student-common-profile-view>
            } @else {
            <div class="p-5 bg-white rounded-lg border text-center text-sm text-zinc-500">
                No HOD details found.
            </div>
            }

        </div>
        <!-- analytics -->
        <div class="lg:col-span-2">
            <div class="flex items-center justify-between">
                <h2 class="text-lg font-semibold border-b-2 border-primary-500 inline-block pb-1">Analytics</h2>
            </div>

            <div class="mt-4">
                <app-classroom-syllabus-card></app-classroom-syllabus-card>
            </div>
        </div>
        <!-- analytics -->

    </div>
</section>
